import { z } from "zod";

export const googleAdsAccountSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, { message: "Account name is required" }),
  accountId: z
    .string()
    .min(1, { message: "Account ID is required" })
    .regex(
      /^[\d -]+$/,
      "Account ID must contain only digits, spaces, or dashes"
    ),
  conversionId: z
    .string()
    .regex(/^\d*$/, "Conversion ID must contain only digits")
    .optional(),
  loginCustomerId: z
    .string()
    .regex(
      /^[\d -]*$/,
      "Login customer ID must contain only digits, spaces, or dashes"
    )
    .optional(),
  submitLeadFormConversionActionId: z
    .string()
    .regex(/^\d+$/, "Submit Lead Form action ID is required"),
  qualifiedLeadConversionActionId: z
    .string()
    .regex(/^\d+$/, "Qualified Lead action ID is required"),
  notes: z.string().optional(),
});

export type TGoogleAdsAccountForm = z.infer<typeof googleAdsAccountSchema>;
